// extracted by extract-css-chunks-webpack-plugin
module.exports = {"customToastNotification":"bMKzRN_S","isClickable":"Zu2oXtaK","toastIcon":"hQDfZ8mc","toastContainer":"DwKU_QqX","toastTitle":"wmQIJH0C","toastMessage":"myqAdMCB"};